import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "../lib/api";

export default function Article() {
  const { slug } = useParams();
  const { t, i18n } = useTranslation();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setArticle(null); setNotFound(false);
    api.get(`/articles/${slug}`).then((r) => setArticle(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <div className="pt-40 pb-24 max-w-3xl mx-auto px-6 text-[#A3A39D]">{t("catalog.empty")}</div>;
  if (!article) return <div className="pt-40 pb-24 max-w-3xl mx-auto px-6 text-[#A3A39D]">{t("catalog.loading")}</div>;

  const fmtDate = (iso) => new Date(iso).toLocaleDateString(i18n.language, { day: "2-digit", month: "long", year: "numeric" });

  return (
    <article data-testid="article-page" className="pt-32 md:pt-40 pb-24">
      <div className="max-w-4xl mx-auto px-6 md:px-12 mb-10">
        <Link to="/revue" className="text-xs uppercase tracking-[0.22em] text-[#D4AF37] hover:text-[#F0C050]">
          {t("revue.back_to_revue")}
        </Link>
      </div>

      <header className="max-w-4xl mx-auto px-6 md:px-12 mb-10">
        <div className="overline mb-5">{article.category}</div>
        <h1 className="font-serif text-4xl md:text-6xl text-[#F5F5F0] leading-[0.95] mb-6">{article.title}</h1>
        <p className="text-sm text-[#A3A39D] tracking-wider">
          {t("revue.by")} <span className="text-[#F5F5F0]">{article.author}</span> · {fmtDate(article.created_at)}
        </p>
      </header>

      <div className="max-w-5xl mx-auto px-6 md:px-12 mb-14">
        <div className="aspect-[16/9] bg-[#151516]">
          <img src={article.cover_image} alt={article.title} className="w-full h-full object-cover" />
        </div>
      </div>

      <div
        className="max-w-3xl mx-auto px-6 md:px-12 text-[#F5F5F0] text-lg leading-[1.8] font-light article-content"
        style={{ fontFamily: "Cormorant Garamond, serif" }}
        data-testid="article-content"
        dangerouslySetInnerHTML={{ __html: article.content }}
      />
    </article>
  );
}
